module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/4pf1abmHC8m44ase4oQys4-ec255ad9549082a9c3fba96de4ae9cb8.jpg";